import { Form as FinalForm, FormProps } from 'react-final-form';

import { setFieldData } from './form.mutators';

/**
 * Компонент формы, обертка вокруг react-final-form с добавленным мутатором setFieldData.
 *
 * @public
 * @typeParam FormValues - Интерфейс значений формы, где ключи - это строки, а значения - любые типы данных.
 * @param props - Свойства формы, передаваемые в react-final-form.
 * @returns Элемент формы.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Form = <FormValues extends Record<string, any>>(
  props: FormProps<FormValues>,
) => <FinalForm {...props} mutators={{ ...props.mutators, setFieldData }} />;
